import * as React from 'react';
export var IconEmail = function IconEmail() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "46",
    height: "46",
    viewBox: "0 0 46 46"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#2B87DB",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 24.9V2h26v22.9l9.2-5-7.2-5.4V1c0-.6-.4-1-1-1H9c-.6 0-1 .4-1 1v13.7L.8 19.9l9.2 5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5 33.9c-.2.1-.3.1-.5.1s-.3 0-.5-.1L0 21.8V44a2 2 0 0 0 2 2h42a2 2 0 0 0 2-2V21.8L23.5 33.9zM30.3 9.3L21 18.6l-3.3-3.3c-.4-.4-1-.4-1.4 0-.4.4-.4 1 0 1.4l4 4c.2.2.4.3.7.3.3 0 .5-.1.7-.3l10-10c.4-.4.4-1 0-1.4-.4-.4-1-.4-1.4 0z"
  })));
};